module.exports = __webpack_public_path__ + "img/Prog-final-Inperson-day2exh-v1.2ccb28b7.svg";